<template>
  <div></div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "flashMessages",
  props: {
    initialMessages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      message: "",
    };
  },
  computed: {
    ...mapGetters({
      messages: "flashMessages/getMessages",
    }),
  },
  watch: {
    messages: {
      immediate: true,
      handler() {
        this.handleMessageArray(this.messages);
      },
    },
  },
  mounted() {
    this.handleMessageArray(this.initialMessages);
  },
  methods: {
    handleMessageArray(messages) {
      messages.forEach(([type, message]) => {
        const flashMessages = Array.isArray(message) ? message : [message];
        flashMessages.forEach(message => {
          this.flash({ type, message });
        });
      });
    },
    flash({ type = "notice", message }) {
      if (type === "notice" || type === "info") {
        this.$toasted.success(message, { icon: "check" });
      }
      if (type === "error") {
        this.$toasted.error(message, { icon: "ban" });
      }
    },
  },
};
</script>
